import TeacherRdSalaryAudit from './src/main';

/* istanbul ignore next */
TeacherRdSalaryAudit.install = function(Vue) {
  Vue.component(TeacherRdSalaryAudit.name, TeacherRdSalaryAudit);
};

export default TeacherRdSalaryAudit;
